import { Box, SxProps } from "@mui/material";
import React, { useMemo } from "react";

export const Logo = ({ sx }: { sx?: SxProps }) => {
  return (
    <Box
      sx={{
        background: "url(/logo.png)",
        width: "141px",
        height: "100px",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        ...(sx || {}),
      }}
    ></Box>
  );
};
